module.exports = __webpack_public_path__ + "static/media/plastic-nozzle.5ca4a52b.png";